import LoadingSpinner from './LoadingSpinner';

const LoadingOverlay = () => {
  return (
    <div style={ {
      position: 'fixed',
      top: 0, left: 0,
      bottom: 0, right: 0,
      zIndex: 5000,
      display: 'grid', placeItems: 'center'
    } } className="acrylic-transparent">
      <div style={ { filter: 'invert(0)' } }><LoadingSpinner /></div>
    </div>
  );
};

export default LoadingOverlay;
